<template>
    <div class="tw-flex tw-justify-center tw-items-center">
      <vs-card class="tw-max-w-3xl tw-text-center">
        <div slot="header">
          <h3>Yetkiniz Yok!</h3>
        </div>

        <img src="@/assets/images/401.png" class="img-fluid" alt="Not Authorized!" style="max-height: 120px;">
          <br>
          <br>
        <h5>Üzgünüz bu sayfayı görüntülemek için yetkiniz yok.</h5>
      </vs-card>

    </div>
</template>

<script>
    export default {
        name: 'PageNotFound',
        title: 'Page Not Found',
    }
</script>

<style>

</style>